import './vendor/element-closest';
import './vendor/docReady';

import './module/menu';
import './module/scroll';
import './module/carousel';
import './module/video';
import './module/modal';
import './module/search-filter';
import './module/service-filter';
import './module/table';
import './module/form';
import './module/accordion';

const vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', vh + 'px');

// remove no js
document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

/* window resize */
window.addEventListener('resize', function() {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
});

// links to other sites open in new windows
var links = document.links;
for (var i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname != window.location.hostname) {
        links[i].target = '_blank';
    }
}

export default {};